/**
 * Library list fetch helper — avoids treating { error } or HTML 401 bodies as empty shelves.
 * @returns {Promise<{ items: unknown[], total: number } | null>}
 */
export async function fetchZflixList(url) {
  const r = await fetch(url);
  if (!r.ok) return null;
  let data;
  try {
    data = await r.json();
  } catch {
    return null;
  }
  if (!data || typeof data !== 'object') return null;
  if (typeof data.error === 'string' && data.items == null) return null;
  return {
    items: Array.isArray(data.items) ? data.items : [],
    total: typeof data.total === 'number' ? data.total : (Array.isArray(data.items) ? data.items.length : 0),
  };
}
